<template>
    <div class="wrapper" >
        <div class="scroller">
            <div class="detail_title_container bottom_line padding_bottom_40">
                <span class="detail_title_style">{{tbReceiptOutput.orderTypeName}}</span>
                <span class="detail_status blue_color">{{receiptStatus[tbReceiptOutput.receiptStatus]}}</span>
            </div>
            <div class="detail_contact bottom_line padding_bottom_40">
                <span class="detail_title_style margin_bottom_14">收件信息</span>
                <div class="detail_contact_container margin_top_14">
                    <span class="detail_text_style">电子邮箱</span>
                    <span class="detail_desc_style detail_email">{{tbReceiptOutput.sendeeEmail}}</span>
                </div>
            </div>
            <div class="detail_contact bottom_line padding_bottom_401">
                <span class="detail_title_style detail_invoice_title">发票信息</span>
                <div class="detail_contact_container margin_top_14">
                    <span class="detail_text_style ">发票抬头</span>
                    <span class="detail_desc_style detail_email">{{tbReceiptOutput.receiptTitle}}</span>
                </div>
                <div class="detail_contact_container margin_top_14" v-if="tbReceiptOutput.receiptType == 2">
                    <span class="detail_text_style ">税号</span>
                    <span class="detail_desc_style detail_email">{{tbReceiptOutput.ratepayingNumber}}</span>
                </div>

                <div class="detail_contact_container margin_top_14">
                    <span class="detail_text_style ">发票内容</span>
                    <span class="detail_desc_style detail_email">{{tbReceiptOutput.receiptContent}}</span>
                </div>
                <div class="detail_contact_container margin_top_14">
                    <span class="detail_text_style ">发票金额</span>
                    <span class="detail_desc_style detail_email blue_color">{{tbReceiptOutput.receiptAmount}}元</span>
                </div>
                <div class="detail_contact_container margin_top_14">
                    <span class="detail_text_style ">申请时间</span>
                    <span class="detail_desc_style detail_email">{{tbReceiptOutput.createTime | formatTime}}</span>
                </div>

            </div>
            <div class="bottom_line flex_between bottom_container_padding">
                <div>
                    <span class="detail_desc_style">1张发票，含{{orderNoSize}}个订单</span>
                    <!--<text class="detail_func_style">联系我们</text>-->
                </div>
                <div class="flex_row" @click="toInvoiceInfo()">
                    <span class="detail_func_style">查看</span>
                    <img class="next_arrow" :src="arrow"/>
                </div>
            </div>
        </div>
        <!--  -->
         <div class="footer" v-if="tbReceiptOutput.receiptStatus == 2" >
            <div :class="['pdiv' ,'canclick']" @click="submit_apply">重发电子发票</div>
        </div>
        <!-- <Footer v-if="tbReceiptOutput.receiptStatus == 2" text="重发电子发票" @btnClick="submit_apply" isClick="true"></Footer> -->
    </div>
</template>

<style scoped>

    .wrapper {
        align-items: center;
        flex: 1;
    }

    .scroller {
        width: 750px;
        flex-direction: column;
        padding-left: 40px;
        padding-right: 40px;
        display: flex;
    }

    .margin_top_14 {
        margin-top: 14px;
    }

    .padding_bottom_401{
        width: 670px;
        display: flex;
        /* padding-top: 24px;*/
        padding-bottom: 20px;
        /* background-color: red; */
    }
    .margin_bottom_14 {
        margin-bottom: 14px;
    }

    .flex_row {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    .flex_between {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .detail_title_container {
        display: flex;
        width: 670px;
        flex-direction: row;
        justify-content: space-between;

    }

    .detail_invoice_title {
        margin-top: 40px;
        margin-bottom: 14px;
    }

    .bottom_line {
        border-bottom-color: #EAEAEA;
        border-bottom-width: 2px;
        border-bottom-style: solid;

    }

    .padding_bottom_40 {
        padding-bottom: 40px;
    }

    .detail_contact {
        display: flex;
        width: 670px;
        flex-direction: column;
    }

    .detail_title_style {
        height: 44px;
        font-size: 32px;
        margin-top: 40px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 44px;
    }

    .detail_text_style {
        width: 115px;
        display: flex;
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 40px;
    }

    .detail_desc_style {
        width: 495px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        line-height: 40px;
    }

    .detail_func_style {
        height: 34px;
        font-size: 24px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 34px;
    }

    .next_arrow {
        width: 11px;
        height: 20px;
        margin-left: 16px;
    }

    .detail_status {
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        margin-top: 40px;
        line-height: 40px;
    }

    .blue_color {
        color: rgba(0, 135, 255, 1);
    }

    .detail_contact_container {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .detail_email {
        margin-left: 60px;
    }

    .bottom_container_padding {
        /* margin-top: 24px;*/
        padding-top: 24px;
        width: 670px;
        display: flex;
        margin-right: 20px;
        padding-bottom: 22px;
    }
    .footer {
        position: fixed;
        bottom:0;left:0;right:0;
        z-index:333;
        background:#fff;
        height:108px;
        width:100%;


    }
    .pdiv{
        display: block;
        margin:16px 28px;
        height:76px;
        line-height:76px;
        text-align:center;
        background:#dadada;
        border-radius: 4px;
        color:#fff;
        font-size:32px;
    }
    .canclick{
        background:#0087ff;
    }
</style>

<script>
    import util from '../../utils/util';
    import storage from '../../utils/storage'
    import {getReceiptDetail} from '../../utils/api';
    import { mapState } from "vuex";
    export default {
        components: {
        },
        computed: {
            ...mapState({
                    common: state => state.common
            })
        },
        data: function() {
        return {
                    arrow:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAqCAYAAACpxZteAAADdklEQVRYR72Xy09USRSHf6fubUNMBuKD2c9q4m4SuPf2ypVxgomZMUYGARGdUaOyNdFdq8TXX2CUlY//AIbG1lEQ6G5yYUHCxhd08JGo4IqE4Nz6TYrQpKe5l37w6GV3V311vqo655Rgiz+Sn398fHxfEARxrbVYlvXCcZx3m8FeBoyNjf1CsgfAzwDMd++VUl2O4zzdKEQSiYRqamq6BODmyuT5OedItiaTyaeJREJXCxLf92Na66skrxRNQpJvRaTL87yBqgFmYCaTOSEidwHsLIaIyCcAHa7rPqsGsrwHmUymVkQeAzgEQBVPJCJfRaS1r6/vWaW6Vk9RNpvdIyK3zGpJ7iiOBMAbkl3xePxJJZGsAsyg0dHR3ZZl3SD5l4hYIZCPJE/E4/Hn5UL+BzCDViJ5SPLXKF1BEBwfGBj4pxxdawAG4vv+XpK3tNYdAGIhG/9aa210pUpFEgowg6ampnYvLCzcJPkngDBdH0Sk3XXdwfUgkYACXY9IHozQ9YVkS39//4soXesCDGRoaKi+pqbmNsn2MF0AXiulLkallZKAgkiMrtPr6GpzXXdozR0qtUn5383Ga63N6YrUpZT6o7e3d7BQV1kR5CETExP1S0tLd0SkLeJ0vQJwsTCtVATI6wJwG0BnlC4ArZ7nvTT/rxiQvydBEJjcdSDsdAH4LCLHHMd5WRXAQEZGRn60bfsOyTYRsUPSSlZEjlQNKIjE6DoZous7yf0bBdQFQWAq4dkQwL8AqgdsqSKTcQGYJuFwyMohIl+01u2e56UqVuT7fp3W2tSMc2HHVETmlFLNjY2NyzWjIsCWXjRT7Wzbvk/ytwgtpm53TE9PP2lubg7yx7asCFKpVF1tbW03gPNRWgC0hHUeJQErSc5cqM1P16W0AJgzlyyXyyULtRTe6sgITK9kWVZ3EAQXIjqMeaVUS6n+dfuL/uTk5K7FxcX7WuvfQ1ZuLpFpijtzuVx/lJZIRUYLgOumaERo+UbyeCXd3fa0jsPDwz/EYrEekkfDtACYF5HOmZmZv8vRskZROp1uU0rdC2vfAXyzbbu1oaGhqjdC/gFyjeTl4qq0KQ8Qksr3/ctaa5MKCo/tvNb61OzsbF+lWtYoymazjSQfAPhJZJlhEtcZ13WT5fZNUf9bXXE6nd5nWZZnohCRwU19xm50leuN/w/gsNFGcnfzOAAAAABJRU5ErkJggg==',
                    tbReceiptOutput: {},
                    receiptStatus: ["开票状态", "已申请", "已开票", "开票失败"],
                    orderList: [],//发票订单数组
                    id:'',
                    orderNoSize: 0
                };
        },
        created() {
            // globalEvent.addEventListener("clickEvent", (e) => {
            //     if (e.backKey && e.backKey == 'keyPress') this.goBack();
            // })
            let query = this.$route.query;
            this.id = query.id;
            this.getReceiptDetail(this.id);
        },
        methods: {
            // 重发电子发票
            submit_apply(){
                 var url ="/invoiceDetailRepeat?id="+this.id +'&email='+this.tbReceiptOutput.sendeeEmail
                 this.$router.push({path:url});
            },
            toInvoiceInfo() {
                if (this.orderList.length > 0) {
                    let orderTypeName = encodeURI(this.tbReceiptOutput.orderTypeName);
                    let orderType = this.tbReceiptOutput.orderType;
                    console.log(orderType)
                    storage.setS("InvoiceInfo_orderList",JSON.stringify(this.orderList))
                    var url ="/invoiceInfo?orderTypeName="+orderTypeName+ "&orderType=" + orderType
                    this.$router.push({path:url});
                }
            },
            getReceiptDetail(id) {
                let params = {
                    "id": id,
                }
                // console.log("params" + JSON.stringify(params))
               getReceiptDetail(params).then(ret => {
                    console.log("ret" + JSON.stringify(ret))
                    if (ret.res.code == '10000') {
                        this.tbReceiptOutput = ret.body.tbReceiptOutput;
                        this.orderNoSize = ret.body.orderNoSize;
                        this.orderList = ret.body.orderList;
                    } else {
                        // modal.toast({message: ret.res.msg, duration: 1})
                        util.showToast(ret.res.msg);
                    }
                })
            },
        },
        filters: {
            formatTime: function (value) {
                // let time = configObj.dataFormat(new Date(value), 'yyyy-MM-dd hh:mm');
                // return time;
                return util.formatTime(new Date(value),10)
            }
        }
    }
</script>